import "@fontsource-variable/archivo";
import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Routing from "./routes/Routing";
import "./styles/site.scss";
import useScrollToTopOnRouteChange from "./utils/hooks/useScrollToTopOnRouteChange";

function App() {
  useScrollToTopOnRouteChange();
  return (
    <div className="site">
      <HelmetProvider>
        <Suspense fallback={<div className="page" />}>
          <Header />
          <Routing />
          <Footer />
        </Suspense>
      </HelmetProvider>
    </div>
  );
}

export default App;
